import { IAttrValue } from "@multiweb/types/contracts";
import { Globalization } from "../../../../../../Global/Dom/Globalization";
import { AttrValueReader } from "../../../../../../OW.Remoting/Remoting/AttrValueReader";
import { IOWObject } from "../../../../../../OW.Remoting/Remoting/DataTypes/IOWObject";
import { Column } from "../../../../../UI.Controls/DataGridSubcontrols/Columns/Column";
import { IColumnDefinition, IColumnParameters, ILovColumnParameters } from "../../../../../UI.Controls/DataGridSubcontrols/Columns/ColumnFactory";
import { LOVTemplate } from "../../../../../UI.Controls/DataGridSubcontrols/Templates/DataTypeTemplates/LOVTemplate";
import { registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IRequiresMasterObject } from "./IRequiresMasterObject";
import { TextLOVEditTemplate } from "./Templates/TextLOVEditTemplate";

export class TextLovColumn extends Column implements IRequiresMasterObject {
    //#region Fields
    public requiresMasterObject: boolean;

    protected override _additionalParameters: ILovColumnParameters;

    private _showAttr: string;
    private _editWindow: string;
    private _condition: string;
    private _conditionParamsAttrs: string;
    private _additionalAttrs: string;
    private _showAdditionalAttrs: string;
    //#endregion Fields

    //#region Properties
    public get showAttr(): string {
        return this._showAttr;
    }

    public get additionalAttrs(): string {
        return this._additionalAttrs;
    }

    public get showAdditionalAttrs(): string {
        return this._showAdditionalAttrs;
    }

    public get editWindow(): string {
        return this._editWindow;
    }

    public get condition(): string {
        return this._condition;
    }

    public get conditionParamsAttrs(): string {
        return this._conditionParamsAttrs;
    }
    //#endregion Properties

    //#region Constructors
    protected override _constructor(): void {
        super._constructor();

        this.requiresMasterObject = true;
        this.itemTemplate = new LOVTemplate();
        this.editItemTemplate = new TextLOVEditTemplate();
    }
    //#endregion Constructors

    //#region Methods
    /**
     * Zinicializuje data sloupce
     * @param definition - definice sloupce
     * @param params - dodatečné parametry
     */
    public override initialize(definition: IColumnDefinition, params?: IColumnParameters): void {
        super.initialize(definition, params);

        if (params != null && params instanceof ILovColumnParameters)
            this._additionalParameters = params;

        // Zpracujeme ihned, šahá se na něj během vytváření sloupců při plnění dataSource (ještě nemusel proběhnout attributeChangedCallback)
        this.attrName = definition.attrName;
        this._showAttr = definition.showAttr;
        this._editWindow = definition.editWindow;
        this._additionalAttrs = definition.additionalAttrs;
        this._showAdditionalAttrs = definition.showAdditionalAttrs;
        this._condition = definition.condition;
        this._conditionParamsAttrs = definition.conditionParams;
    }

    public override async formatValue(data: IAttrValue | IAttrValue[]): Promise<string> {
        let frmVal: string;
        if (data instanceof Array) {
            let values: IAttrValue[];
            if (data.length === 1) {
                const firstValue = AttrValueReader.read(data[0]);
                values = firstValue instanceof IOWObject ? await firstValue.getValues([this._showAttr]) : data;
            } else {
                values = data;
            }
            frmVal = values.map((item) => Globalization.formatValue(AttrValueReader.read(item))).filter((item) => item.trim().length > 0)
                .join("</span><span> | </span><span class='textlov-attribute'>");
        } else {
            frmVal = Globalization.formatValue(AttrValueReader.read(data));
        }
        return `<span class='textlov-attribute first-attr'>${frmVal}</span>`;
    }

    protected override attributeChangedCallback(attrName: string, oldVal: string, newVal: string): void {
        super.attributeChangedCallback(attrName, oldVal, newVal);

        switch (attrName) {
            case "data-ShowAttr":
                this._showAttr = newVal;
                break;
            case "data-AdditionalAttrs":
                this._additionalAttrs = newVal;
                break;
            case "data-ShowAdditionalAttrs":
                this._showAdditionalAttrs = newVal;
                break;
            case "data-EditWindow":
                this._editWindow = newVal;
                break;
            case "data-Condition":
                this._condition = newVal;
                break;
            case "data-Conditionparams":
                this._conditionParamsAttrs = newVal;
                break;
        }
    }
    //#endregion Methods
}

registerCustomElement("tsc-xgtextlovcolumn", TextLovColumn);
